import { useState } from "react";
import { Button, CircularProgress, useTheme } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  backendUrl,
  customerName,
  apiVersion,
} from "../../constants/constants";

const AccessButton = ({
  userId,
  token,
  applicationId,
  handleAlert,
  handleRender,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    try {
      setLoading(true);
      const apiUrl = `${backendUrl}/${apiVersion}/grantNewAssignments`;
      const response = await axios.post(
        apiUrl,
        [
          {
            grantAccessTo: userId,
          },
        ],
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            customerName: customerName,
            applicationId: applicationId,
          },
        }
      );
      response.status === 200 && handleAlert(true);
    } catch (error) {
      console.log("error in grant access:", error);
    } finally {
      setLoading(false);
      handleRender();
    }
  };

  return (
    <Button
      variant="outlined"
      sx={{
        fontWeight: "bold",
        padding: 1,
        fontSize: 12,
        maxWidth: "60%",
        [theme.breakpoints.down("sm")]: {
          marginTop: "16px",
        },
      }}
      size="large"
      onClick={handleClick}
      fullWidth
      disabled={loading ? true : false}
    >
      {loading ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        t("buttons.grantAccess")
      )}
    </Button>
  );
};

export default AccessButton;
